import React from 'react';
import { AxiosResponse } from 'axios';
import { getTasks, getAchievements, claimAchievement } from 'shared/api/queries/progress';
import { useProgressStore, useGlobalStore } from 'shared/store';
import { TaskEntity } from 'shared/types';
import { Achievement } from 'shared/types/api';
import { handleSettledPromise, replaceUrl } from 'shared/utils';
import { useAlert } from 'shared/ui/components/alert/alert';
import { useTranslation } from 'react-i18next';
import { AmountWithTokenData, DON_TOKEN } from 'components';

export const useProgress = () => {
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const { setTasks, setAchievements } = useProgressStore((state) => state);
  const updateUser = useGlobalStore((state) => state.updateUser);

  const fetchTasksAndAchievements = async () => {
    try {
      const [tasksRes, achievementsRes] = await Promise.allSettled([getTasks(), getAchievements()]);

      handleSettledPromise<AxiosResponse<TaskEntity[]>>({
        promise: tasksRes,
        callback: (result) => {
          setTasks(result.data.map((item) => ({ ...item, icon: replaceUrl(item.icon) })));
        },
      });

      handleSettledPromise<AxiosResponse<Achievement[]>>({
        promise: achievementsRes,
        callback: (result) => {
          setAchievements(result.data.map((item) => ({ ...item, icon: replaceUrl(item.icon) })));
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClaimAchievement = async (achievementId: string) => {
    try {
      const response = await claimAchievement(achievementId);

      if (response.data.success) {
        // Обновляем пользователя
        updateUser(response.data.user);

        // Показываем успешное сообщение
        showAlert(
          <>
            <div>{t('progress.achievement_claimed')}:</div>
            <AmountWithTokenData
              amount={`${response.data.reward}`}
              token={DON_TOKEN}
              decimals={0}
              tokenTitle={true}
            />
          </>,
        );

        // Обновляем все achievements
        await fetchTasksAndAchievements();
      }
    } catch (error) {
      console.error('Failed to claim achievement:', error);
      showAlert(t('alerts.something_went_wrong'));
    }
  };

  return {
    fetchTasksAndAchievements,
    handleClaimAchievement,
  };
};
